import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { MODULE_NOT_IN_PLAN_MESSAGE } from "@/modules/moduleAccess";
import { buildConfiguracionRenovacionUrl } from "@/modules/config/configuracionRoutes";

/**
 * Aviso freemium cuando una acción crítica requiere módulo no contratado.
 * La seguridad real permanece en el backend.
 */
export default function ModulePlanBlockedDialog({ open, onOpenChange }) {
  const navigate = useNavigate();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="module-plan-blocked-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Módulo no disponible en su plan</AlertDialogTitle>
          <AlertDialogDescription>{MODULE_NOT_IN_PLAN_MESSAGE}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-sm">Cerrar</AlertDialogCancel>
          <AlertDialogAction
            className="rounded-sm bg-[#0F2D5C] hover:bg-[#0a2248]"
            onClick={() => {
              onOpenChange?.(false);
              navigate(buildConfiguracionRenovacionUrl());
            }}
          >
            Solicitar habilitación
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
